import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type {
    NoveltySearchPic2TextApi,
    NoveltySearchPic2TextRequest,
    NoveltySearchPic2TextResponseData,
} from '../novelty-search-pic2text-api';
import { coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';
import { PsHttpService, type PatSnapSuccessResponseData } from '@patsnap/tahiti-core';

/**
 * 新颖性检索图片转文本API实现
 * @description 实现将图片转换为文本描述的API操作
 */
@injectable()
export class NoveltySearchPic2TextApiImpl extends PsHttpService implements NoveltySearchPic2TextApi {

    get options() {
        return {
            baseURL: coreTelecomApiUrlPrefix,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    /**
     * 将图片转换为文本描述
     * @param data 图片转文本请求参数
     * @returns 图片描述结果
     * @description 调用后端API将图片内容转换为文本描述
     */
    async pic2Text(data: NoveltySearchPic2TextRequest): Promise<NoveltySearchPic2TextResponseData> {
        const response = await this.post<PatSnapSuccessResponseData<NoveltySearchPic2TextResponseData>>({
            url: 'novelty-search/novelty_search_pic2t',
            data,
        });
        return response.data;
    }
}
